"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
class PromocodeApi {
    constructor(api) {
        this.api = api;
    }
    getPromocodeValidate(merchantId, code) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = '/c/promocode/validate';
            const params = {
                merchantId,
                code,
            };
            const response = yield this.api.axiosGo.get(endpoint, { params });
            return response.data;
        });
    }
}
exports.default = PromocodeApi;
//# sourceMappingURL=PromoCode.js.map